import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { getSummary } from "./thunks/get-summary";

const name = "summary";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSummary.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(getSummary.fulfilled, (state, action) => {
        state.summary = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(getSummary.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
